export const DOCUMENT_FLAG_COLOURS = ['#0086FF', '#104F9E', '#39AA96', '#FEAD02', '#FF6E32', '#FF3B32', '#8E5CD9', '#6C78A0'];

export class DocumentFlagUtils {

  static textColour(backgroundColour: string): string {
    if (!/^#[0-9A-Fa-f]{6}$/.test(backgroundColour ?? '')) {
      return '#1F2A44';
    }
    const hex = backgroundColour.substring(1);
    const [r, g, b] = [0, 2, 4].map(i => parseInt(hex.substring(i, i + 2), 16));
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.6 ? '#1F2A44' : '#FFFFFF';
  }
}
